/**
 * Exercise Type registry keys and the configuration bounds both sides check.
 */
/** FR-005 — the first Exercise Type this platform shipped. */
export const NOTE_IDENTIFICATION = 'note_identification';
/** A text question with text answer options, one of them correct. */
export const MULTIPLE_CHOICE = 'multiple_choice';
/**
 * Every key this build knows. Deliberately a plain string list, mirroring
 * `exercise.exercise_type` being `text` rather than a Postgres enum: adding a
 * type must not require a schema migration (FR-003, SC-009).
 */
export const EXERCISE_TYPES = [NOTE_IDENTIFICATION, MULTIPLE_CHOICE];
/**
 * FR-041 — the answer-option count is an integer from 2 to 9 inclusive, and
 * must not exceed the size of the Exercise's configured note pool.
 *
 * The lower bound keeps the Exercise a genuine choice; the upper bound keeps
 * every presented option addressable by a single number key (FR-043, FR-044).
 * Shared because `apps/api` enforces it and the admin UI mirrors it inline.
 */
export const MIN_OPTION_COUNT = 2;
export const MAX_OPTION_COUNT = 9;
export function isExerciseTypeKey(value) {
    return typeof value === 'string' && EXERCISE_TYPES.includes(value);
}
/**
 * How a Lesson's Exercises reach the learner.
 *
 * `fixed` presents them in the order the administrator arranged. `random`
 * leaves that arrangement untouched in the database and shuffles it per
 * learner on the way out — the shuffle is derived from the learner and the
 * Lesson, so it differs between two learners and is IDENTICAL on every read
 * for one of them. That stability is not a nicety: the learner's position is
 * re-resolved from content order on every request
 * (`apps/api/src/learning/position-resolver.ts`), so an order that re-rolled
 * would move somebody mid-Lesson without their asking.
 */
export const EXERCISE_ORDER_FIXED = 'fixed';
export const EXERCISE_ORDER_RANDOM = 'random';
export const EXERCISE_ORDERS = [EXERCISE_ORDER_FIXED, EXERCISE_ORDER_RANDOM];
export function isExerciseOrder(value) {
    return typeof value === 'string' && EXERCISE_ORDERS.includes(value);
}
//# sourceMappingURL=exercise-types.js.map